import { User } from 'src/app/shared/models/user.model';
import { Wallet } from 'src/app/shared/models/wallet.model';

export class UserAssetModel {
  user: User;
  wallet: Wallet[];

  constructor(input: any) {
    this.user = new User(input.user);
    this.wallet = input.wallet?.map((w: any) => new Wallet(w));
  }
}
